import { tool, zodSchema } from 'ai';
import { z } from 'zod';
import type { AiTool } from '@erikdakoda/ai-tool/types';
import { withAiToolNestedParamSchema } from '@erikdakoda/ai-tool/findManyAiToolInput';
import { botsToolGroupIcon } from './toolGroupIcon';

export const childPromptRowInputSchema = z.object({
  promptId: z.string().describe('Child prompt template id to attach'),
  ord: z.number().int().min(0).describe('Display order on the bot'),
  values: z
    .record(z.string(), z.string())
    .optional()
    .nullable()
    .describe('Variable substitutions JSON object'),
});

export const updateBotPromptsInputSchema = z.object({
  botId: z.string(),
  childPrompts: withAiToolNestedParamSchema(
    z.array(childPromptRowInputSchema).min(0).max(50),
    'childPrompts',
  ).describe('Full ordered list to apply; replaces existing child prompts on the bot.'),
});

export const updateBotPromptsOutputSchema = z.object({
  count: z.number().int(),
  success: z.string().nullable(),
  error: z.unknown().nullable(),
});

export type UpdateBotPromptsInput = z.infer<typeof updateBotPromptsInputSchema>;
export type UpdateBotPromptsOutput = z.infer<typeof updateBotPromptsOutputSchema>;

export const updateBotPrompts: AiTool<undefined, UpdateBotPromptsInput, UpdateBotPromptsOutput> = {
  id: 'updateBotPrompts',

  group: 'bots',

  ...botsToolGroupIcon,

  userSelect: false,

  access: 'WRITE',

  tool: tool({
    description: `Replace all ChildPrompt rows for a bot with the given ordered list.

- Use with existing prompts; does not create Prompt records.`,
    inputSchema: zodSchema(updateBotPromptsInputSchema),
    outputSchema: zodSchema(updateBotPromptsOutputSchema),
  }),
};
